import { useState, useEffect } from 'react'

const BackToTop = () => {
  const [isVisible, setIsVisible] = useState(false)
  const [isFading, setIsFading] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY
      setIsVisible(scrollTop > 300)
      setIsFading(scrollTop > 1200)
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const scrollToTop = (e: React.MouseEvent) => {
    e.preventDefault()
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <a
      href="#0"
      className={`cd-top ${isVisible ? 'cd-is-visible' : ''} ${isFading ? 'cd-fade-out' : ''}`}
      onClick={scrollToTop}
    >
      Top
    </a>
  )
}

export default BackToTop


